import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.header
            initial={{ y: -60, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "border-b border-amber-400/10 bg-[#050507]/80 backdrop-blur-xl"
                    : "border-b border-transparent bg-transparent"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
                <a
                    href="#top"
                    data-testid="teg-nav-logo"
                    className="group flex items-center gap-3"
                    aria-label="Truth Excellence Group — back to top"
                >
                    <span className="font-display flex h-9 w-9 items-center justify-center rounded-md border border-amber-400/40 bg-gradient-to-br from-amber-300/15 to-transparent text-sm font-semibold tracking-widest text-amber-300 shadow-[0_0_18px_rgba(212,175,55,0.25)] transition-shadow duration-300 group-hover:shadow-[0_0_28px_rgba(212,175,55,0.45)]">
                        TEG
                    </span>
                    <span className="font-display hidden text-xs font-medium tracking-[0.28em] text-slate-200 sm:block">
                        TRUTH EXCELLENCE GROUP
                    </span>
                </a>

                <nav className="flex items-center gap-5 sm:gap-8" aria-label="Primary">
                    <a
                        href="#brands"
                        data-testid="teg-nav-brands-link"
                        className="font-mono-lux text-[11px] tracking-[0.25em] text-slate-300 uppercase transition-colors duration-300 hover:text-amber-300"
                    >
                        Our Brands
                    </a>
                    <a
                        href="#contact"
                        data-testid="teg-nav-contact-link"
                        className="font-mono-lux text-[11px] tracking-[0.25em] text-slate-300 uppercase transition-colors duration-300 hover:text-amber-300"
                    >
                        Contact
                    </a>
                    <a
                        href="#contact"
                        data-testid="teg-nav-contact-btn"
                        className="font-mono-lux hidden rounded-full border border-amber-400/50 px-5 py-2 text-[11px] tracking-[0.25em] text-amber-300 uppercase transition-all duration-300 hover:bg-amber-400/10 hover:shadow-[0_0_24px_rgba(212,175,55,0.35)] sm:inline-block"
                    >
                        Let's Talk
                    </a>
                </nav>
            </div>
        </motion.header>
    );
}
